import { useState } from 'react';
import Layout from '../../Global/Layout';
import { LOTTO_TYPE } from '../../../contexts/constants';

const AccordionItem = ({ title, children, isOpen, onToggle, titleColor }) => {
	return (
		<div className="border border-gray-300 dark:border-gray-600 rounded-lg overflow-hidden">
			<button
				onClick={onToggle}
				className="w-full px-6 py-4 flex items-center justify-between bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
			>
				<h3 className={`text-lg font-semibold ${titleColor} text-left`}>
					{title}
				</h3>
				<svg
					className={`w-5 h-5 text-gray-600 dark:text-gray-400 transition-transform duration-200 ${
						isOpen ? 'rotate-180' : ''
					}`}
					fill="none"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth="2"
					viewBox="0 0 24 24"
					stroke="currentColor"
				>
					<path d="M19 9l-7 7-7-7"></path>
				</svg>
			</button>
			<div
				className={`overflow-hidden transition-all duration-500 ease-in-out ${
					isOpen ? 'opacity-100' : 'max-h-0 opacity-0'
				}`}
			>
				<div className="px-6 py-4 bg-gray-50 dark:bg-gray-900 border-t border-gray-300 dark:border-gray-600">
					<div className="text-gray-700 dark:text-gray-300 space-y-3">
						{children}
					</div>
				</div>
			</div>
		</div>
	);
};

const UserManual = ({ onLogout, userRole }) => {
	const [openIndex, setOpenIndex] = useState(null);

	if (!['sysadmin', 'owner', 'admin', 'agent', 'customer'].includes(userRole)) {
		window.location.href = '/forbidden';
		return null;
	}

	const toggleAccordion = (index) => {
		setOpenIndex(openIndex === index ? null : index);
	};

	const manualItems = [
		{
			title: 'วิธีการเปิดขาย',
			roles: ['sysadmin', 'owner', 'admin'],
			title_color: '',
			content: (
				<>
					<p>1. เข้าเมนู "กำหนดผลรางวัล {LOTTO_TYPE.powerball}" หรือ "กำหนดผลรางวัล {LOTTO_TYPE.megamillions}"</p>
					<p>2. กรอกรายละเอียดที่จำเป็นให้ครบถ้วน ได้แก่ วันที่ออกรางวัล, วันที่เปิดขาย, วันที่ปิดขาย, สถานะการเปิดขาย, ราคาขาย จากนั้นกด "บันทึก"<br/>&nbsp;&nbsp;&nbsp;<span className='text-red-600 dark:text-red-400'>* สถานะการเปิดขาย จะเปิดได้ทีละรายการต่อประเภทเท่านั้น</span></p>
					<div className="mb-4 flex justify-center">
						<img
							src="user_manual/open_buy/1.png"
							alt="ขั้นตอนการเปิดขาย"
							className="w-full max-w-2xl rounded-lg shadow-md"
						/>
					</div>
					<p>3. เมื่อเปิดการขายแล้ว ลูกค้าจะสามารถเข้ามาซื้อได้ ตามเวลาที่กำหนดไว้</p>
					<div className="mb-4 flex justify-center">
						<img
							src="user_manual/open_buy/2.png"
							alt="หลังจากเปิดขายแล้ว"
							className="w-full max-w-2xl rounded-lg shadow-md"
						/>
					</div>
				</>
			)
		},
		{
			title: 'วิธีการซื้อ',
			roles: ['sysadmin', 'customer', 'agent'],
			title_color: '',
			content: (
				<>
					<p>1. เข้าสู่เมนู "สั่งซื้อ"</p>
					<p>2. เลือกประเภทที่ต้องการซื้อ "{LOTTO_TYPE.powerball}" หรือ "{LOTTO_TYPE.megamillions}"</p>
					<p>3. เลือกเลขที่ต้องการ หรือใช้ระบบสุ่มเลข</p>
					<p>&nbsp;&nbsp;&nbsp; 3.1. กด "สุ่มเลข" หรือพิมพ์เลขที่ต้องการ</p>
					<div className="mb-4 flex justify-center">
						<img
							src="user_manual/buy/1.png"
							alt="เลือกเลขที่ต้องการซื้อ"
							className="w-full max-w-2xl rounded-lg shadow-md"
						/>
					</div>
					<p>&nbsp;&nbsp;&nbsp; 3.2. กด "เลือกเลข" เมื่อเลือกเลขที่ต้องการแล้ว ให้กดปุ่ม "เสร็จสิ้น"</p>
					<div className="mb-4 flex justify-center">
						<img
							src="user_manual/buy/2.png"
							alt="เลือกเลขที่ต้องการซื้อ"
							className="w-full max-w-2xl rounded-lg shadow-md"
						/>
					</div>
					<p>4. กด "เพิ่มใบซื้อ" เพื่อซื้อตามจำนวนที่ต้องการ จากนั้นให้กด "ยืนยันการซื้อ"</p>
					<div className="mb-4 flex justify-center">
						<img
							src="user_manual/buy/3.png"
							alt="ยืนยันการซื้อ"
							className="w-full max-w-2xl rounded-lg shadow-md"
						/>
					</div>
					<p>5. ระบบจะแสดง "สรุปรายการซื้อเลข" ให้ตรวจสอบความถูกต้อง</p>
					<p>&nbsp;&nbsp;&nbsp; 5.1. หากต้องการใช้ส่วนลด ให้ติ๊กเลือกส่วนลดที่ต้องการ</p>
					<p>&nbsp;&nbsp;&nbsp; 5.2. เมื่อตรวจสอบ หรือเลือกส่วนลดเรียบร้อยแล้ว ให้กด "ดำเนินการชำระเงิน"</p>
					<div className="mb-4 flex justify-center">
						<img
							src="user_manual/buy/4.png"
							alt="ดำเนินการชำระเงิน"
							className="w-full max-w-2xl rounded-lg shadow-md"
						/>
					</div>
					<p>6. ดำเนินการชำระเงิน ระบบจะแสดงรายละเอียดการชำระเงิน</p>
					<p>&nbsp;&nbsp;&nbsp; 6.1. ชำระเงินตามยอดที่ระบบสรุปให้ และต้องชำระเงินภายในระยะเวลาที่กำหนด หากเกินระยะเวลารายการจะถูกยกเลิก</p>
					<div className="mb-4 flex justify-center">
						<img
							src="user_manual/buy/5.png"
							alt="รายละเอียดการชำระเงิน"
							className="w-full max-w-2xl rounded-lg shadow-md"
						/>
					</div>
					<p>&nbsp;&nbsp;&nbsp; 6.2. แนบสลิปการโอนเงิน</p>
					<div className="mb-4 flex justify-center">
						<img
							src="user_manual/buy/6.png"
							alt="แนบสลิปการโอนเงิน"
							className="w-full max-w-2xl rounded-lg shadow-md"
						/>
					</div>
					<p>&nbsp;&nbsp;&nbsp; 6.3. เสร็จแล้วกด "ยืนยันการชำระเงิน"</p>
					<p>&nbsp;&nbsp;&nbsp; 6.4. เมื่อชำระเงินเรียบร้อย ต้องรอแอดมินอนุมัติคำสั่งซื้อ</p>
					<div className="mb-4 flex justify-center">
						<img
							src="user_manual/buy/7.png"
							alt="รอแอดมินอนุมัติคำสั่งซื้อ"
							className="w-full max-w-2xl rounded-lg shadow-md"
						/>
					</div>
					<p>7. ตรวจสอบสถานะคำสั่งซื้อได้ที่เมนู "ประวัติการสั่งซื้อ"</p>
					<div className="mb-4 flex justify-center">
						<img
							src="user_manual/buy/8.png"
							alt="ตรวจสอบสถานะคำสั่งซื้อ"
							className="w-full max-w-2xl rounded-lg shadow-md"
						/>
					</div>
				</>
			)
		},
		{
			title: 'วิธีการอนุมัติการซื้อ',
			roles: ['sysadmin', 'owner', 'admin'],
			title_color: '',
			content: (
				<>
					<p>1. เข้าสู่เมนู "ตรวจสอบ/อนุมัติการชำระเงิน"</p>
					<p>&nbsp;&nbsp;&nbsp; 1.1. ระบบจะแสดงจำนวนคำสั่งซื้อที่รอตรวจสอบ</p>
					<p>&nbsp;&nbsp;&nbsp; 1.2. ระบบจะแสดงจำนวนใบ ของทุกคำสั่งซื้อที่รอตรวจสอบ</p>
					<p>&nbsp;&nbsp;&nbsp; 1.3. ระบบจะแสดงยอดเงินรวม ของทุกคำสั่งซื้อที่รอตรวจสอบ</p>
					<div className="mb-4 flex justify-center">
						<img
							src="user_manual/approve_payment/1.png"
							alt="ตรวจสอบคำสั่งซื้อที่รอตรวจสอบ"
							className="w-full max-w-2xl rounded-lg shadow-md"
						/>
					</div>
					<p>2. การจัดการคำสั่งซื้อที่รอตรวจสอบ</p>
					<div className="mb-4 flex justify-center">
						<img
							src="user_manual/approve_payment/2.png"
							alt="จัดการคำสั่งซื้อที่รอตรวจสอบ"
							className="w-full max-w-2xl rounded-lg shadow-md"
						/>
					</div>
					<p>&nbsp;&nbsp;&nbsp; 2.1. กดปุ่ม "ดูสลิป" เพื่อดูรายละเอียดการคำสั่งซื้อก่อน "อนุมัติ" หรือ "ปฏิเสธ"</p>
					<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2.1.1. ระบบจะแสดงรายละเอียดคำสั่งซื้อ</p>
					<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2.1.2. ระบบจะแสดงสลิปการโอนเงิน</p>
					<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2.1.3. กดปุ่ม "อนุมัติ" เพื่ออนุมัติคำสั่งซื้อ โดยจำเป็นเหมือนข้อ 2.2. </p>
					<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2.1.4. กดปุ่ม "ปฏิเสธ" เพื่อปฏิเสธคำสั่งซื้อ โดยจำเป็นเหมือนข้อ 2.3.</p>
					<div className="mb-4 flex justify-center">
						<img
							src="user_manual/approve_payment/5.png"
							alt="ดูรายละเอียดคำสั่งซื้อ"
							className="w-full max-w-2xl rounded-lg shadow-md"
						/>
					</div>
					<p>&nbsp;&nbsp;&nbsp; 2.2. กดปุ่ม "อนุมัติ" เพื่ออนุมัติคำสั่งซื้อ</p>
					<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2.2.1. ระบบจะแสดงข้อมูลคำสั่งซื้อ</p>
					<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2.2.2. กดปุ่ม "อนุมัติ" เพื่อยืนยันการอนุมัติคำสั่งซื้อ</p>
					<div className="mb-4 flex justify-center">
						<img
							src="user_manual/approve_payment/3.png"
							alt="ยืนยันการอนุมัติคำสั่งซื้อ"
							className="w-full max-w-2xl rounded-lg shadow-md"
						/>
					</div>
					<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2.2.3. เมื่อยืนยันการอนุมัติคำสั่งซื้อสำเร็จ ระบบจะแสดงข้อความแจ้ง</p>
					<div className="mb-4 flex justify-center">
						<img
							src="user_manual/approve_payment/6.png"
							alt="ยืนยันการอนุมัติคำสั่งซื้อสำเร็จ"
							className="w-full max-w-2xl rounded-lg shadow-md"
						/>
					</div>
					<p>&nbsp;&nbsp;&nbsp; 2.3. กดปุ่ม "ปฏิเสธ" เพื่อปฏิเสธคำสั่งซื้อ</p>
					<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2.3.1. ระบบจะแสดงข้อมูลคำสั่งซื้อ</p>
					<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2.3.2. ต้องระบุเหตุผลในการปฏิเสธคำสั่งซื้อ</p>
					<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2.3.3. กดปุ่ม "ปฏิเสธ" เพื่อยืนยันการปฏิเสธคำสั่งซื้อ</p>
					<div className="mb-4 flex justify-center">
						<img
							src="user_manual/approve_payment/4.png"
							alt="ปฏิเสธคำสั่งซื้อ"
							className="w-full max-w-2xl rounded-lg shadow-md"
						/>
					</div>
					<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2.3.4. เมื่อยืนยันการปฏิเสธคำสั่งซื้อสำเร็จ ระบบจะแสดงข้อความแจ้ง</p>
					<div className="mb-4 flex justify-center">
						<img
							src="user_manual/approve_payment/7.png"
							alt="ยืนยันการปฏิเสธคำสั่งซื้อสำเร็จ"
							className="w-full max-w-2xl rounded-lg shadow-md"
						/>
					</div>
				</>
			)
		},
		{
			title: 'วิธีการปิดการขายและสรุปผลรางวัล',
			roles: ['sysadmin', 'owner', 'admin'],
			title_color: '',
			content: (
				<>
					<p>1. ตรวจสอบผลรางวัลของตนเองที่เมนู "รายการตารางทุกงวด"</p>
					<div className="mb-4 flex justify-center">
						<img
							src="user_manual/close_buy/1.png"
							alt="ตรวจสอบผลรางวัลของตนเองที่เมนู รายการตารางทุกงวด"
							className="w-full max-w-2xl rounded-lg shadow-md"
						/>
					</div>
					<p>2. จัดการการปิดการขายและสรุปผลรางวัล</p>
					<p>&nbsp;&nbsp;&nbsp; 2.1. กดปุ่ม "แก้ไข" เพื่อแก้ไขข้อมูลการปิดการขาย</p>
					<p>&nbsp;&nbsp;&nbsp; 2.2. กดปุ่ม "รายการสั่งซื้อ" เพื่อดูรายการสั่งซื้อ</p>
					<div className="mb-4 flex justify-center">
						<img
							src="user_manual/close_buy/2.png"
							alt="จัดการการปิดการขายและสรุปผลรางวัล"
							className="w-full max-w-2xl rounded-lg shadow-md"
						/>
					</div>
					<p>3. กรอกข้อมูลการปิดการขาย</p>
					<p>&nbsp;&nbsp;&nbsp; 3.1. กรอกลิงค์ YouTube ที่เผยแพร่ผลรางวัล</p>
					<p>&nbsp;&nbsp;&nbsp; 3.2. เลือกสถานะเป็นปิดรับคำสั่งซื้อ</p>
					<p>&nbsp;&nbsp;&nbsp; 3.3. กรอกผลรางวัลที่ออกในงวดนั้นๆ</p>
					<p>&nbsp;&nbsp;&nbsp; 3.4. กรอกจำนวนเงิน (บาท) ที่จะได้รับเมื่อถูกรางวัล ของแต่ละ Match</p>
					<p>&nbsp;&nbsp;&nbsp; 3.5. กรอกจำนวนเงิน (Dollar) ไว้ดูเพื่ออ้างอิงราคา (บาท)</p>
					<p>&nbsp;&nbsp;&nbsp; 3.6. กดปุ่ม "สรุปผลรางวัล" เพื่อบันทึกข้อมูลการปิดการขายและเริ่มสรุปผลรางวัล</p>
					<div className="mb-4 flex justify-center">
						<img
							src="user_manual/close_buy/3.png"
							alt="กรอกข้อมูลการปิดการขาย"
							className="w-full max-w-2xl rounded-lg shadow-md"
						/>
					</div>
					<p>4. ระบบจะให้ยืนยันการสรุปผลรางวัล</p>
					<p>&nbsp;&nbsp;&nbsp; 4.1. แสดงข้อความแจ้งเตือนก่อนยืนยันการสรุปผลรางวัล</p>
					<p>&nbsp;&nbsp;&nbsp; 4.2. กดปุ่ม "ยืนยัน" เพื่อยืนยันการสรุปผลรางวัล</p>
					<div className="mb-4 flex justify-center">
						<img
							src="user_manual/close_buy/4.png"
							alt="ยืนยันการสรุปผลรางวัล"
							className="w-full max-w-2xl rounded-lg shadow-md"
						/>
					</div>
					<p>5. สรุปผลรางวัลสำเร็จ</p>
					<p>&nbsp;&nbsp;&nbsp; 5.1. แสดงข้อความแจ้งเตือนการสรุปผลรางวัลสำเร็จ</p>
					<p>&nbsp;&nbsp;&nbsp; 5.2. แสดงสถานะ "สรุปแล้ว" เพื่อบ่งบอกว่าสรุปผลรางวัลเรียบร้อยแล้ว</p>
					<p>&nbsp;&nbsp;&nbsp; 5.3. กดปุ่ม "รายการสั่งซื้อ" เพื่อดูรายละเอียดรายการสั่งซื้อที่ถูกรางวัล</p>
					<div className="mb-4 flex justify-center">
						<img
							src="user_manual/close_buy/5.png"
							alt="สรุปผลรางวัลสำเร็จ"
							className="w-full max-w-2xl rounded-lg shadow-md"
						/>
					</div>
					<p>6. ใบที่ถูกรางวัลจะมีเครื่องหมายติ๊กถูกเลขที่ถูกรางวัลอยู่</p>
					<div className="mb-4 flex justify-center">
						<img
							src="user_manual/close_buy/6.png"
							alt="ใบที่ถูกรางวัล"
							className="w-full max-w-2xl rounded-lg shadow-md"
						/>
					</div>
					<p>7. ลูกค้าดูใบที่ถูกรางวัลได้ที่เมนู "ประวัติการสั่งซื้อ"</p>
					<p>&nbsp;&nbsp;&nbsp; 7.1. ใบที่ถูกรางวัลจะมีเครื่องหมายติ๊กถูกเลขที่ถูกรางวัลอยู่</p>
					<p>&nbsp;&nbsp;&nbsp; 7.2. จะมีจำนวนเงินที่ได้รับแสดงอยู่</p>
					<div className="mb-4 flex justify-center">
						<img
							src="user_manual/close_buy/7.png"
							alt="ใบที่ถูกรางวัล"
							className="w-full max-w-2xl rounded-lg shadow-md"
						/>
					</div>
				</>
			)
		},
		{
			title: 'วิธีจ่ายเงินรางวัลให้ลูกค้าที่ถูก',
			roles: ['sysadmin', 'owner', 'admin'],
			title_color: '',
			content: (
				<>
					<p>1. ตรวจสอบผลรางวัลของลูกค้าที่เมนู "ลูกค้าที่ถูกรางวัล"</p>
					<div className="mb-4 flex justify-center">
						<img
							src="user_manual/wining_payment/1.png"
							alt="ตรวจสอบผลรางวัลของลูกค้าที่เมนู ลูกค้าที่ถูกรางวัล"
							className="w-full max-w-2xl rounded-lg shadow-md"
						/>
					</div>
					<p>2. กดที่ปุ่ม "จ่ายเงิน" เพื่อทำการจ่ายเงินรางวัลให้ลูกค้าที่ถูกรางวัล</p>
					<div className="mb-4 flex justify-center">
						<img
							src="user_manual/wining_payment/2.png"
							alt="จ่ายเงินรางวัลให้ลูกค้าที่ถูกรางวัล"
							className="w-full max-w-2xl rounded-lg shadow-md"
						/>
					</div>
					<p>3. ตรวจสอบรายละเอียด และแนบหลักฐานการจ่ายเงิน</p>
					<div className="mb-4 flex justify-center">
						<img
							src="user_manual/wining_payment/3.png"
							alt="ตรวจสอบรายละเอียด และแนบหลักฐานการจ่ายเงิน"
							className="w-full max-w-2xl rounded-lg shadow-md"
						/>
					</div>
					<p>4. เมื่อแนบหลักฐานการจ่ายเงินเรียบร้อยแล้ว กดปุ่ม "อัพโหลดและบันทึก"</p>
					<div className="mb-4 flex justify-center">
						<img
							src="user_manual/wining_payment/4.png"
							alt="อัพโหลดและบันทึกหลักฐานการจ่ายเงิน"
							className="w-full max-w-2xl rounded-lg shadow-md"
						/>
					</div>
					<p>5. ระบบจะแสดงข้อความแจ้ง จากนั้นให้กดปุ่ม "ตกลง" เพื่อยืนยันการจ่ายเงินรางวัล</p>
					<div className="mb-4 flex justify-center">
						<img
							src="user_manual/wining_payment/5.png"
							alt="ยืนยันการจ่ายเงินรางวัล"
							className="w-full max-w-2xl rounded-lg shadow-md"
						/>
					</div>
					<p>6. ระบบจะแสดงข้อความแจ้ง และสถานะจะเป็น "จ่ายแล้ว"</p>
					<div className="mb-4 flex justify-center">
						<img
							src="user_manual/wining_payment/6.png"
							alt="จ่ายเงินรางวัลเรียบร้อย"
							className="w-full max-w-2xl rounded-lg shadow-md"
						/>
					</div>
				</>
			)
		},
		{
			title: 'วิธีตรวจสอบผลรางวัลของตนเอง',
			roles: ['sysadmin', 'customer'],
			title_color: '',
			content: (
				<>
					<p>1. ตรวจสอบผลรางวัลของตนเองที่เมนู "ประวัติการสั่งซื้อ"</p>
					<p>&nbsp;&nbsp;&nbsp; 1.1. จะต้องเป็นรายการที่มีสถานะ "อนุมัติแล้ว" เท่านั้น</p>
					<div className="mb-4 flex justify-center">
						<img
							src="user_manual/check_result/1.png"
							alt="ตรวจสอบผลรางวัลของตนเอง"
							className="w-full max-w-2xl rounded-lg shadow-md"
						/>
					</div>
					<p>&nbsp;&nbsp;&nbsp; 1.2. กดปุ่ม "ค้นหา" เพื่อกรอกข้อมูลที่ต้องการตรวจสอบ</p>
					<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ติ๊ก "ถูกผลรางวัล" จากนั้นกด "ค้นหา"</p>
					<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ระบบจะแสดงรายละเอียดรางวัลและจำนวนเงินที่ได้รับ</p>
					<div className="mb-4 flex justify-center">
						<img
							src="user_manual/check_result/2.png"
							alt="ตรวจสอบผลรางวัลของตนเอง"
							className="w-full max-w-2xl rounded-lg shadow-md"
						/>
					</div>
				</>
			)
		},
		{
			title: 'วิธีตรวจสอบผลรางวัลของลูกค้าที่ถูก',
			roles: ['sysadmin', 'owner', 'admin', 'agent'],
			title_color: '',
			content: (
				<>
					<p>1. ตรวจสอบผลรางวัลของลูกค้าที่เมนู "ลูกค้าที่ถูกรางวัล"</p>
					<p>&nbsp;&nbsp;&nbsp; 1.1. ระบบจะแสดงงวดปัจจุบันที่เปิดอยู่</p>
					<p>&nbsp;&nbsp;&nbsp; 1.2. สามารถเลือกค้นหาผู้ถูกรางวัลของงวดอื่นๆได้</p>
					<p>&nbsp;&nbsp;&nbsp; 1.3. ระบบจะแสดงรายชื่อลูกค้าที่ถูกรางวัลของงวดปัจจุบัน</p>
					<p>&nbsp;&nbsp;&nbsp; 1.4. สามารถดูหลักฐานการจ่ายเงินได้</p>
					<div className="mb-4 flex justify-center">
						<img
							src="user_manual/customer_result/1.png"
							alt="ตรวจสอบผลรางวัลของตนเอง"
							className="w-full max-w-2xl rounded-lg shadow-md"
						/>
					</div>
				</>
			)
		}
	];

	// กรอง manualItems ตาม userRole
	const filteredManualItems = manualItems.filter(item =>
		item.roles.includes(userRole)
	);

	return (
		<Layout title="คู่มือการใช้งาน" onLogout={onLogout} userRole={userRole}>
			<div className="space-y-4">
				<div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6 mb-6">
					<p className="text-gray-600 dark:text-gray-400 mb-6">
						คู่มือการใช้งานเบื้องต้น
					</p>
					<div className="space-y-3">
						{filteredManualItems.map((item, index) => (
							<AccordionItem
								key={index}
								title={item.title}
								isOpen={openIndex === index}
								onToggle={() => toggleAccordion(index)}
								titleColor={item.title_color}
							>
								{item.content}
							</AccordionItem>
						))}
					</div>
				</div>
			</div>
		</Layout>
	);
};

export default UserManual;
